import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Trans, withTranslation } from "react-i18next";
import TextField from "@material-ui/core/TextField";
import { DatePicker } from "@material-ui/pickers";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import { withStyles } from "@material-ui/core/styles";
import DocumentAutosuggest from "./../document/DocumentAutosuggest";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import Checkbox from "@material-ui/core/Checkbox";
import ListItemText from "@material-ui/core/ListItemText";
import IconButton from "@material-ui/core/IconButton";
import ClearIcon from "@material-ui/icons/Clear";
import Divider from "@material-ui/core/Divider";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import UserAutosuggest from "./../UserAutosuggest";
import { convertDocumentRVO } from "./../../utils/KpsUtils";
import TeamAutosuggest from "./../TeamAutosuggest";
import Snackbar from "@material-ui/core/Snackbar";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import axios, { taxServiceClient } from "../../AxiosClient";
import UserTeamPicker from "./UserTeamPicker";
import ActionButton from "../ActionButton";
import { withSnackbar } from "notistack";
import CardList from "../../core-elements/CardList";
import ItemRequiredReadingDocument from "../list-item/ItemRequiredReadingDocument";
import FilterWrapper from "../filter/FilterWrapper";
import Alert from "@material-ui/lab/Alert";
import KpsTextField from "../KpsTextField";
const styles = (theme) => ({
  cancelButton: {
    margin: "0 auto 0 0",
  },
  infoContainer: {
    display: "flex",
    flexDirection: "column",
  },
  expiry: {
    marginLeft: 30,
  },
  textField: {
    marginBottom: 10,
  },
  paper: {
    overflow: "visible",
  },
});

export class RequiredReadingDialog extends Component {
  state = {
    open: true,
    title: "",
    description: "",
    notificationDate: null,
    expiryDate: null,
    activeStep: 0,
    documents: this.props.initialDocuments ? this.props.initialDocuments : [],
    users: [],
    instance: new Date().getTime().toString(),
    teams: [],
    userLists: [],
    teamUsers: [],
    saving: false,
    filters: {
      sort: "createdDate",
      sortDirection: "DESC",
      draft: "Live",
      titleContains: "",
      favourited: false,
      liked: false,
      viewed: false,
      modifiedSinceLastSeen: false,
      onlyCreatedRecently: false,
      modifiedInLast: 0,
      taxonomyDialogOpen: false,
      createdBy: [],
      modifiedBy: [],
      taxonomy: [],
      createdStart: "",
      createdEnd: "",
      modifiedStart: "",
      modifiedEnd: "",
      loadingUsers: false,
    },
    unviewableDocuments: [],
  };

  componentDidMount = () => {
    axios.post("/userlist/list/", {withCredentials: true}).then((res) => {
      this.setState({ userLists: res.data.content });
    });
  };

  onFilterChange = (filter) => {
    if (filter.hasOwnProperty("taxonomy") === true) {
      if (
        filter.taxonomy.filter(
          (ele) =>
            ele.type === "taxonomy" &&
            ele.parentList &&
            ele.parentList.length === 0
        ).length > 0
      ) {
        filter.taxonomy = [];
      }
    }
    this.setState({
      filters: filter,
    });
  };

  render() {
    const { classes, t } = this.props;
    return (
      <div style={{ height: "100%" }}>
        <Dialog
          fullWidth={this.state.activeStep === 1}
          open={this.props.fromMenu ? this.state.open : this.props.open}
          onClose={this.props.handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          classes={{ paper: classes.paper }}
          maxWidth="lg"
        >
          <DialogTitle id="alert-dialog-title">
            <Trans i18nKey="create_required_reading_header" />
          </DialogTitle>
          <DialogContent>
            <Stepper activeStep={this.state.activeStep} alternativeLabel>
              <Step>
                <StepLabel>
                  <Trans i18nKey="required_reading_stepper_task_info" />
                </StepLabel>
              </Step>
              <Step>
                <StepLabel>
                  <Trans i18nKey="required_reading_stepper_pick_documents" />
                </StepLabel>
              </Step>
              <Step>
                <StepLabel>
                  <Trans i18nKey="required_reading_stepper_select_users" />
                </StepLabel>
              </Step>
            </Stepper>
            {this.state.activeStep === 0 && (
              <div>
                <Typography
                  style={{ marginBottom: 10 }}
                  id="alert-dialog-description"
                >
                  <Trans i18nKey="required_reading_info_header" />
                </Typography>
                <div className={classes.infoContainer}>
                  <KpsTextField
                    autoFocus
                    id="required-reading-title"
                    required
                    label={t("personal_details_title_label")}
                    inputProps={{ maxLength: 128 }}
                    value={this.state.title}
                    className={classes.textField}
                    onChange={this.handleChange("title")}
                  />

                  <KpsTextField
                    id="required-reading-description"
                    required
                    label={t("required_reading_description_label")}
                    inputProps={{ maxLength: 256 }}
                    multiline
                    rowsMax="4"
                    value={this.state.description}
                    className={classes.textField}
                    onChange={this.handleChange("description")}
                  />
                  <div>
                    <DatePicker
                      minDate={new Date()}
                      id="required-reading-notification-date"
                      required
                      autoOk
                      label={t("required_reading_notification_date_label")}
                      clearable
                      disablePast
                      value={this.state.notificationDate}
                      className={classes.textField}
                      onChange={this.handleDateChange("notificationDate")}
                    />

                    <DatePicker
                      id="required-reading-expiry-date"
                      required
                      className={classes.expiry}
                      autoOk
                      minDate={this.state.notificationDate}
                      disabled={!this.state.notificationDate}
                      label={t("required_reading_expiry_date_label")}
                      clearable
                      disablePast
                      value={this.state.expiryDate}
                      onChange={this.handleDateChange("expiryDate")}
                    />
                  </div>
                </div>
              </div>
            )}
            {this.state.activeStep === 1 && (
              <>
                <Typography style={{ marginTop: 5, marginBottom: 20 }}>
                  <Trans i18nKey="required_reading_document_header" />
                </Typography>
                <div className={classes.infoContainer}>
                  <FilterWrapper
                    asPopper={false}
                    open={true}
                    filterElement={"FilterDocuments"}
                    filter={this.state.filters}
                    onFilterChange={this.onFilterChange}
                    isFilterBar={false}
                    title={this.state.filterTitle}
                    showReset={this.state.haveFiltersChanged}
                    resetToDefaultFilters={this.resetToDefaultFilters}
                    filterInstance={this.state.filterInstance}
                    disabledFilters={["draft"]}
                  />
                  <div
                    style={{ height: 300, marginBottom: 10 }}
                    id="required-reading-document-list"
                  >
                    <CardList
                      parameters={this.state.filters}
                      listItem={ItemRequiredReadingDocument}
                      isPortlet={false}
                      selectedDocuments={this.state.documents}
                      listOnly
                      onItemClick={this.onDocumentSelected}
                      portlet={{ id: Math.floor(Math.random() * 1000) + 1 }}
                      listItemTitleColumn={{
                        name: "title",
                        message: "global_document_title",
                      }}
                      messageType="com.kpsol.api.apicommon.document.DocumentInterface"
                    />
                  </div>
                  <Typography style={{ marginTop: 30, marginBottom: -5 }}>
                    <Trans i18nKey="required_reading_or_user_lists" />
                  </Typography>
                  <FormControl className={classes.formControl}>
                    <InputLabel htmlFor="age-simple">
                      <Trans i18nKey="global_user_list_plural" />
                    </InputLabel>
                    <Select
                      value={this.state.userList}
                      onChange={this.handleUserListChange}
                    >
                      {this.state.userLists.map((ele, idx) => {
                        return (
                          <MenuItem key={idx} value={ele.id}>
                            {ele.title}
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </FormControl>
                </div>
              </>
            )}
            {this.state.activeStep === 2 && (
              <>
                <UserTeamPicker
                  onUsersUpdate={this.onUsersUpdate}
                  onTeamUsersUpdate={this.onTeamUsersUpdate}
                  onTeamSelected={this.onTeamSelected}
                  userHeaderKey="required_reading_users_header"
                  userTeamHeaderKey="required_reading_users_team_header"
                  loadingUsers={this.loadingUsers}
                />
                {this.state.unviewableDocuments.length > 0 && (
                  <Alert
                    severity="warning"
                    style={{
                      width: "fit-content",
                      marginLeft: "auto",
                      marginRight: "auto",
                    }}
                    elevation={3}
                  >
                    One or more of the teams selected cannot see all the
                    documents selected ({this.state.unviewableDocuments.map(
                      (doc) => {
                        return doc.userTitle + ", ";
                      }
                    )})
                  </Alert>
                )}
              </>
            )}
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.handleClose}
              color="primary"
              className={classes.cancelButton}
            >
              <Trans i18nKey="global_cancel" />
            </Button>
            {this.state.activeStep > 0 && (
              <Button onClick={this.handleBack} color="primary" autoFocus>
                <Trans i18nKey="">
                  <Trans i18nKey="global_back" />
                </Trans>
              </Button>
            )}
            <ActionButton
              onClick={this.handleNext}
              color="primary"
              autoFocus
              loading={this.state.saving}
              disabled={this.isNextDisabled() || this.state.loadingUsers}
            >
              {this.state.activeStep === 2 ? (
                <Trans i18nKey="global_create" />
              ) : (
                <Trans i18nKey="global_next" />
              )}
            </ActionButton>
          </DialogActions>
        </Dialog>
      </div>
    );
  }

  loadingUsers = (e) => {
    this.setState({ loadingUsers: e });
  };

  isNextDisabled = () => {
    if (this.state.activeStep === 0) {
      return (
        !this.state.title ||
        !this.state.description ||
        !this.state.notificationDate ||
        !this.state.expiryDate
      );
    }
    return false;
  };

  onUsersUpdate = (users) => {
    this.setState({ users });
  };

  onTeamUsersUpdate = (teamUsers) => {
    this.setState({ teamUsers });
  };
  onTeamSelected = (team) => {
    taxServiceClient.get(`/topic/team/${team.teamId}`, {withCredentials: true}).then((res) => {
      let unviewable = [];
      this.state.documents.filter((doc) => {
        !res.data.includes(doc.topicId) && unviewable.push(doc);
      });
      this.setState({ unviewableDocuments: unviewable });
    });
  };
  handleUserListChange = (e) => {
    axios.get(`/userlist/${e.target.value}`, {withCredentials: true}).then((res) => {
      res.data.forEach((ele) => {
        axios.get(`/document/${ele.id}`, {withCredentials: true}).then((res) => {
          this.setState({
            documents: [...this.state.documents, res.data.content],
          });
        });
      });
    });
  };

  handleClose = () => {
    if (this.props.fromMenu) {
      this.setState({ open: false });
      this.props.onClose();
    } else {
      this.props.handleClose();
    }
  };

  removeDocument = (doc) => {
    this.setState({
      documents: this.state.documents.filter((ele) => {
        if (ele.documentId) {
          return ele.documentId !== doc.documentId;
        } else if (ele.documentID) {
          return ele.documentID !== doc.documentID;
        } else {
          return ele.id !== doc.id;
        }
      }),
    });
  };

  onDocumentSelected = (doc) => {
    if (
      this.state.documents.filter((d) => d.documentID === doc.documentID)
        .length === 0
    ) {
      this.setState({ documents: [...this.state.documents, doc] });
    } else {
      this.setState({
        documents: this.state.documents.filter(
          (d) => d.documentID !== doc.documentID
        ),
      });
    }
  };

  handleBack = () => {
    this.setState({ activeStep: this.state.activeStep - 1 });
  };

  handleNext = () => {
    if (this.state.activeStep < 2) {
      this.setState({ activeStep: this.state.activeStep + 1 });
    } else {
      this.setState({ saving: true });
      let requiredReadingRVO = {
        title: this.state.title,
        description: this.state.description,
        expiry: this.state.expiryDate,
        alert: this.state.notificationDate,
        created: new Date().getTime().toString(),
        requiredReadingDocuments: this.state.documents.map((doc) => {
          return convertDocumentRVO(doc);
        }),
        requiredReadingUserIds: this.state.users
          .map((e) => {
            return e.userId;
          })
          .concat(this.state.teamUsers),
      };
      axios
        .post("/requiredreading/", {
          ...requiredReadingRVO,
        })
        .then(() => {
          this.props.enqueueSnackbar(
            this.props.t("create_required_reading_snackbar_success"),
            { variant: "success" }
          );
          this.handleClose();
          this.setState({ saving: false });
        })
        .catch(() => {
          this.props.enqueueSnackbar(
            this.props.t("create_required_reading_snackbar_error"),
            { variant: "error" }
          );
          this.setState({ saving: false });
        });
    }
  };

  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.value });
  };

  handleDateChange = (name) => (e) => {
    this.setState({ [name]: e });
  };
}

export default withTranslation()(
  withStyles(styles)(withSnackbar(RequiredReadingDialog))
);
